'use client';

import { useSignalDetecting } from '@/hooks/use-signal-detecting';

export const SignalDetectClient = () => {
    useSignalDetecting();
    return <></>;
};
